import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientMedicationControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientUuid?: string;
  appointmentUuid?: any;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  active?: boolean;
  searchString?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientPortalMedicationListHealthRecord = ({
  patientUuid,
  appointmentUuid,
  pagination,
  gridSorting,
  status,
  archive,
  active: current,
  searchString,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "patient-medication-list",
      xTENANTID,
      pageIndex,
      current,
      gridSorting,
      sortData,
    ],
    enabled: enabled,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new PatientMedicationControllerApi(getConfigObject())
        .getPatientMedication(
          patientUuid,
          appointmentUuid,
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          status,
          archive,
          current,
          searchString,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};

